import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  onNext: () => void;
}

const EmailForwardingStep: React.FC<Props> = ({ onNext }) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-text dark:text-text-dark">{t('wizard.emailForwarding.title')}</h2>
        <p className="text-muted dark:text-muted-dark mt-2">{t('wizard.emailForwarding.subtitle')}</p>
      </div>

      <div className="rounded-xl bg-zinc-50 dark:bg-zinc-800/50 p-6 space-y-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center flex-shrink-0">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="text-blue-600 dark:text-blue-400" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
          </div>
          <div>
            <h3 className="font-semibold text-text dark:text-text-dark">{t('wizard.emailForwarding.forwardTo')}</h3>
            <code className="text-sm text-emerald-600 dark:text-emerald-400 font-mono bg-emerald-50 dark:bg-emerald-900/20 px-2 py-0.5 rounded">
              invoices@culinarycloud.nl
            </code>
          </div>
        </div>

        <div className="border-t border-zinc-200 dark:border-zinc-700 pt-4 space-y-3">
          <div>
            <h4 className="text-sm font-semibold text-text dark:text-text-dark">{t('wizard.emailForwarding.gmailTitle')}</h4>
            <ol className="text-sm text-muted dark:text-muted-dark mt-1 list-decimal list-inside space-y-1">
              <li>{t('wizard.emailForwarding.gmailStep1')}</li>
              <li>{t('wizard.emailForwarding.gmailStep2')}</li>
              <li>{t('wizard.emailForwarding.gmailStep3')}</li>
            </ol>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-text dark:text-text-dark">{t('wizard.emailForwarding.outlookTitle')}</h4>
            <ol className="text-sm text-muted dark:text-muted-dark mt-1 list-decimal list-inside space-y-1">
              <li>{t('wizard.emailForwarding.outlookStep1')}</li>
              <li>{t('wizard.emailForwarding.outlookStep2')}</li>
              <li>{t('wizard.emailForwarding.outlookStep3')}</li>
            </ol>
          </div>
        </div>
      </div>

      <p className="text-xs text-muted dark:text-muted-dark text-center">
        {t('wizard.emailForwarding.optional')}
      </p>

      <div className="flex justify-end">
        <button
          onClick={onNext}
          className="px-6 py-3 rounded-xl bg-zinc-900 dark:bg-zinc-100 text-white dark:text-zinc-900 hover:bg-zinc-800 dark:hover:bg-zinc-200 transition font-medium"
        >
          {t('wizard.next')}
        </button>
      </div>
    </div>
  );
};

export default EmailForwardingStep;
